import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import storeConfigs from "egov-ui-kit/redux/store";
import employeeReducer from "./reducer";

let { rootReducer, middlewares } = storeConfigs;
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  combineReducers({
    ...rootReducer,
    employee: employeeReducer,
  }),
    composeEnhancers(applyMiddleware(...middlewares))

  // compose(applyMiddleware(...middlewares), window.devToolsExtension ? window.devToolsExtension() : (f) => f)
);

export default store;



// WEBPACK FOOTER //
// src/redux/store/index.js